import {FC} from 'react';

export const CloseIcon: FC<{height?: string; width?: string; strokeWidth?: string}> = ({
  height = '20px',
  width = '20px',
  strokeWidth = '2'
}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.59106 22.5L22.5911 1.5M1.59106 1.5L22.5911 22.5" stroke="#212124" strokeWidth={strokeWidth} />
    </svg>
  );
};
